import React, { useEffect, useMemo, useState } from "react";
import { Projects } from "../../Data/Data";

const HerroSection = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = useMemo(
    () => [Projects[0].herroImg, Projects[1].herroImg],
    []
  );

  const [scrollY, setScrollY] = useState(0);
  // const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    /* a */

    window.addEventListener("scroll", handleScroll);
    // window.addEventListener("resize", handleResize);

    // Initial check
    // handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      // window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative h-[calc(50vh)] md:h-max w-full text-primary-bg-light overflow-hidden bg-inherit flex items-start xl:items-center justify-center md:mt-[56px]">
      <div
        className="max-w-full w-full h-[50vh] md:h-[100vh]  overflow-hidden"
        style={{
          transform: `translateY(-${scrollY * 0.1}px)`,
          transition: "transform 1s",
        }}
      >
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Hero ${index}`}
            loading="lazy"
            className={`
              absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-full w-full h-[50vh] ${
                index === 1 ? "md:h-[140vh]" : "md:h-auto"
              } text-center align-middle object-cover transition-opacity duration-[2s] ease-in-out
              ${index === currentImage ? "opacity-100 z-10" : "opacity-0 z-0"}
            `}
          />
        ))}
      </div>
    </div>
  );
};

export default HerroSection;
